import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Mission from "@/components/Mission";
import Services from "@/components/Services";
import Inventory from "@/components/Inventory";
import Family from "@/components/Family";
import PrivateSearch from "@/components/PrivateSearch";
import Financing from "@/components/Financing";
import Concierge from "@/components/Concierge";
import Tarifs from "@/components/Tarifs";
import VideoBand from "@/components/VideoBand";
import Fleet from "@/components/Fleet";
import WhyUs from "@/components/WhyUs";
import Testimonials from "@/components/Testimonials";
import Process from "@/components/Process";
import Footer from "@/components/Footer";

export default function Home() {
  return (
    <div data-testid="home-page" className="bg-ink min-h-screen">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <Inventory />
        <Family />
        <PrivateSearch />
        <Financing />
        <Concierge />
        <Tarifs />
        <VideoBand />
        <Fleet />
        <WhyUs />
        <Testimonials />
        <Process />
        <Mission />
      </main>
      <Footer />
    </div>
  );
}
